/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ActivateCustomerSpecificPricingAgreementRequest,
  AgreementUsageStats,
  CancelPricingAgreementRequest,
  CompanyCustomerSpecificPricing,
  CreatePricingAgreementsRequest,
  CustomerSpecificCoverageResult,
  CustomerSpecificPricingAgreement,
  DeclinePricingAgreementRequest,
  EmailDescription,
  MarkExistingCustomerRequest,
  SetCspOpportunityNarrativeRequest,
  SetCustomerSpecificPricingForCompanyRequest,
  SetPricingAgreementTurnRequest,
} from "../models/index";
import {
  ActivateCustomerSpecificPricingAgreementRequestFromJSON,
  ActivateCustomerSpecificPricingAgreementRequestToJSON,
  AgreementUsageStatsFromJSON,
  AgreementUsageStatsToJSON,
  CancelPricingAgreementRequestFromJSON,
  CancelPricingAgreementRequestToJSON,
  CompanyCustomerSpecificPricingFromJSON,
  CompanyCustomerSpecificPricingToJSON,
  CreatePricingAgreementsRequestFromJSON,
  CreatePricingAgreementsRequestToJSON,
  CustomerSpecificCoverageResultFromJSON,
  CustomerSpecificCoverageResultToJSON,
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementToJSON,
  DeclinePricingAgreementRequestFromJSON,
  DeclinePricingAgreementRequestToJSON,
  EmailDescriptionFromJSON,
  EmailDescriptionToJSON,
  MarkExistingCustomerRequestFromJSON,
  MarkExistingCustomerRequestToJSON,
  SetCspOpportunityNarrativeRequestFromJSON,
  SetCspOpportunityNarrativeRequestToJSON,
  SetCustomerSpecificPricingForCompanyRequestFromJSON,
  SetCustomerSpecificPricingForCompanyRequestToJSON,
  SetPricingAgreementTurnRequestFromJSON,
  SetPricingAgreementTurnRequestToJSON,
} from "../models/index";

export interface ActivatePricingAgreementRequest {
  activateCustomerSpecificPricingAgreementRequest: ActivateCustomerSpecificPricingAgreementRequest;
}

export interface AgreementUsageStatsRequest {
  companyId?: string | null;
}

export interface CancelPricingAgreementOperationRequest {
  cancelPricingAgreementRequest: CancelPricingAgreementRequest;
}

export interface CreatePricingAgreementsOperationRequest {
  createPricingAgreementsRequest: CreatePricingAgreementsRequest;
}

export interface DeclinePricingAgreementOperationRequest {
  declinePricingAgreementRequest: DeclinePricingAgreementRequest;
}

export interface EvaluateAgreedCoverageRequest {
  companyId: string;
}

export interface EvaluateCoverageRequest {
  companyId: string;
}

export interface MarkPricingAgreementAsExistingCustomerRequest {
  markExistingCustomerRequest: MarkExistingCustomerRequest;
}

export interface MarkPricingAgreementFinalizingRequest {
  agreementId: string;
}

export interface MovePricingAgreementToDraftRequest {
  agreementId: string;
}

export interface PreviewCspOpportunityEmailRequest {
  pricingAgreementId: string;
}

export interface SendCspOpportunityEmailRequest {
  pricingAgreementId: string;
  companyDocumentIds?: Array<string> | null;
  toAddresses?: Array<string> | null;
  ccEmail?: Array<string> | null;
}

export interface SetCspOpportunityNarrativeOperationRequest {
  setCspOpportunityNarrativeRequest: SetCspOpportunityNarrativeRequest;
}

export interface SetCustomerSpecificPricingForCompanyOperationRequest {
  setCustomerSpecificPricingForCompanyRequest: SetCustomerSpecificPricingForCompanyRequest;
}

export interface SetPricingAgreementTurnOperationRequest {
  setPricingAgreementTurnRequest: SetPricingAgreementTurnRequest;
}

export interface UpdatePricingAgreementsRequest {
  customerSpecificPricingAgreement: CustomerSpecificPricingAgreement;
}

/**
 *
 */
export class CustomerSpecificPricingApi extends runtime.BaseAPI {
  /**
   */
  async activatePricingAgreementRaw(
    requestParameters: ActivatePricingAgreementRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters["activateCustomerSpecificPricingAgreementRequest"] ==
      null
    ) {
      throw new runtime.RequiredError(
        "activateCustomerSpecificPricingAgreementRequest",
        'Required parameter "activateCustomerSpecificPricingAgreementRequest" was null or undefined when calling activatePricingAgreement().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/activate-pricing-agreement`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ActivateCustomerSpecificPricingAgreementRequestToJSON(
          requestParameters["activateCustomerSpecificPricingAgreementRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async activatePricingAgreement(
    requestParameters: ActivatePricingAgreementRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.activatePricingAgreementRaw(requestParameters, initOverrides);
  }

  /**
   */
  async agreementUsageStatsRaw(
    requestParameters: AgreementUsageStatsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<AgreementUsageStats>>> {
    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/agreement-usage-stats`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AgreementUsageStatsFromJSON),
    );
  }

  /**
   */
  async agreementUsageStats(
    requestParameters: AgreementUsageStatsRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<AgreementUsageStats>> {
    const response = await this.agreementUsageStatsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async cancelPricingAgreementRaw(
    requestParameters: CancelPricingAgreementOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["cancelPricingAgreementRequest"] == null) {
      throw new runtime.RequiredError(
        "cancelPricingAgreementRequest",
        'Required parameter "cancelPricingAgreementRequest" was null or undefined when calling cancelPricingAgreement().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/cancel-pricing-agreement`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CancelPricingAgreementRequestToJSON(
          requestParameters["cancelPricingAgreementRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async cancelPricingAgreement(
    requestParameters: CancelPricingAgreementOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.cancelPricingAgreementRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createPricingAgreementsRaw(
    requestParameters: CreatePricingAgreementsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["createPricingAgreementsRequest"] == null) {
      throw new runtime.RequiredError(
        "createPricingAgreementsRequest",
        'Required parameter "createPricingAgreementsRequest" was null or undefined when calling createPricingAgreements().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/create-pricing-agreements`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreatePricingAgreementsRequestToJSON(
          requestParameters["createPricingAgreementsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createPricingAgreements(
    requestParameters: CreatePricingAgreementsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createPricingAgreementsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async declinePricingAgreementRaw(
    requestParameters: DeclinePricingAgreementOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["declinePricingAgreementRequest"] == null) {
      throw new runtime.RequiredError(
        "declinePricingAgreementRequest",
        'Required parameter "declinePricingAgreementRequest" was null or undefined when calling declinePricingAgreement().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/decline-pricing-agreement`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeclinePricingAgreementRequestToJSON(
          requestParameters["declinePricingAgreementRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async declinePricingAgreement(
    requestParameters: DeclinePricingAgreementOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.declinePricingAgreementRaw(requestParameters, initOverrides);
  }

  /**
   */
  async evaluateAgreedCoverageRaw(
    requestParameters: EvaluateAgreedCoverageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomerSpecificCoverageResult>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling evaluateAgreedCoverage().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/agreed-carrier-coverage`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomerSpecificCoverageResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async evaluateAgreedCoverage(
    requestParameters: EvaluateAgreedCoverageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomerSpecificCoverageResult> {
    const response = await this.evaluateAgreedCoverageRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async evaluateCoverageRaw(
    requestParameters: EvaluateCoverageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomerSpecificCoverageResult>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling evaluateCoverage().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/evaluate-carrier-coverage`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CustomerSpecificCoverageResultFromJSON(jsonValue),
    );
  }

  /**
   */
  async evaluateCoverage(
    requestParameters: EvaluateCoverageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomerSpecificCoverageResult> {
    const response = await this.evaluateCoverageRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getAllCustomerSpecificPricingAgreementsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CompanyCustomerSpecificPricing>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/all`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CompanyCustomerSpecificPricingFromJSON),
    );
  }

  /**
   */
  async getAllCustomerSpecificPricingAgreements(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CompanyCustomerSpecificPricing>> {
    const response =
      await this.getAllCustomerSpecificPricingAgreementsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async markPricingAgreementAsExistingCustomerRaw(
    requestParameters: MarkPricingAgreementAsExistingCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["markExistingCustomerRequest"] == null) {
      throw new runtime.RequiredError(
        "markExistingCustomerRequest",
        'Required parameter "markExistingCustomerRequest" was null or undefined when calling markPricingAgreementAsExistingCustomer().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/mark-pricing-agreement-as-existing-customer`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: MarkExistingCustomerRequestToJSON(
          requestParameters["markExistingCustomerRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markPricingAgreementAsExistingCustomer(
    requestParameters: MarkPricingAgreementAsExistingCustomerRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markPricingAgreementAsExistingCustomerRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async markPricingAgreementFinalizingRaw(
    requestParameters: MarkPricingAgreementFinalizingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["agreementId"] == null) {
      throw new runtime.RequiredError(
        "agreementId",
        'Required parameter "agreementId" was null or undefined when calling markPricingAgreementFinalizing().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["agreementId"] != null) {
      queryParameters["agreementId"] = requestParameters["agreementId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/mark-pricing-agreement-finalizing`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markPricingAgreementFinalizing(
    requestParameters: MarkPricingAgreementFinalizingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markPricingAgreementFinalizingRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async movePricingAgreementToDraftRaw(
    requestParameters: MovePricingAgreementToDraftRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["agreementId"] == null) {
      throw new runtime.RequiredError(
        "agreementId",
        'Required parameter "agreementId" was null or undefined when calling movePricingAgreementToDraft().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["agreementId"] != null) {
      queryParameters["agreementId"] = requestParameters["agreementId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/move-pricing-agreement-to-draft`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async movePricingAgreementToDraft(
    requestParameters: MovePricingAgreementToDraftRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.movePricingAgreementToDraftRaw(requestParameters, initOverrides);
  }

  /**
   */
  async previewCspOpportunityEmailRaw(
    requestParameters: PreviewCspOpportunityEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EmailDescription>> {
    if (requestParameters["pricingAgreementId"] == null) {
      throw new runtime.RequiredError(
        "pricingAgreementId",
        'Required parameter "pricingAgreementId" was null or undefined when calling previewCspOpportunityEmail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["pricingAgreementId"] != null) {
      queryParameters["pricingAgreementId"] =
        requestParameters["pricingAgreementId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/preview-opportunity-email`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EmailDescriptionFromJSON(jsonValue),
    );
  }

  /**
   */
  async previewCspOpportunityEmail(
    requestParameters: PreviewCspOpportunityEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EmailDescription> {
    const response = await this.previewCspOpportunityEmailRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async sendCspOpportunityEmailRaw(
    requestParameters: SendCspOpportunityEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["pricingAgreementId"] == null) {
      throw new runtime.RequiredError(
        "pricingAgreementId",
        'Required parameter "pricingAgreementId" was null or undefined when calling sendCspOpportunityEmail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["pricingAgreementId"] != null) {
      queryParameters["pricingAgreementId"] =
        requestParameters["pricingAgreementId"];
    }

    if (requestParameters["companyDocumentIds"] != null) {
      queryParameters["companyDocumentIds"] = requestParameters[
        "companyDocumentIds"
      ]!.join(runtime.COLLECTION_FORMATS["csv"]);
    }

    if (requestParameters["toAddresses"] != null) {
      queryParameters["toAddresses"] = requestParameters["toAddresses"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["ccEmail"] != null) {
      queryParameters["ccEmail"] = requestParameters["ccEmail"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/send-opportunity-email`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sendCspOpportunityEmail(
    requestParameters: SendCspOpportunityEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.sendCspOpportunityEmailRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setCspOpportunityNarrativeRaw(
    requestParameters: SetCspOpportunityNarrativeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["setCspOpportunityNarrativeRequest"] == null) {
      throw new runtime.RequiredError(
        "setCspOpportunityNarrativeRequest",
        'Required parameter "setCspOpportunityNarrativeRequest" was null or undefined when calling setCspOpportunityNarrative().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/set-csp-opportunity-narrative`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetCspOpportunityNarrativeRequestToJSON(
          requestParameters["setCspOpportunityNarrativeRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCspOpportunityNarrative(
    requestParameters: SetCspOpportunityNarrativeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCspOpportunityNarrativeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setCustomerSpecificPricingForCompanyRaw(
    requestParameters: SetCustomerSpecificPricingForCompanyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters["setCustomerSpecificPricingForCompanyRequest"] == null
    ) {
      throw new runtime.RequiredError(
        "setCustomerSpecificPricingForCompanyRequest",
        'Required parameter "setCustomerSpecificPricingForCompanyRequest" was null or undefined when calling setCustomerSpecificPricingForCompany().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/set-customer-specific-pricing-for-company`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetCustomerSpecificPricingForCompanyRequestToJSON(
          requestParameters["setCustomerSpecificPricingForCompanyRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCustomerSpecificPricingForCompany(
    requestParameters: SetCustomerSpecificPricingForCompanyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCustomerSpecificPricingForCompanyRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setPricingAgreementTurnRaw(
    requestParameters: SetPricingAgreementTurnOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["setPricingAgreementTurnRequest"] == null) {
      throw new runtime.RequiredError(
        "setPricingAgreementTurnRequest",
        'Required parameter "setPricingAgreementTurnRequest" was null or undefined when calling setPricingAgreementTurn().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/set-pricing-agreement-turn`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SetPricingAgreementTurnRequestToJSON(
          requestParameters["setPricingAgreementTurnRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setPricingAgreementTurn(
    requestParameters: SetPricingAgreementTurnOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setPricingAgreementTurnRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updatePricingAgreementsRaw(
    requestParameters: UpdatePricingAgreementsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["customerSpecificPricingAgreement"] == null) {
      throw new runtime.RequiredError(
        "customerSpecificPricingAgreement",
        'Required parameter "customerSpecificPricingAgreement" was null or undefined when calling updatePricingAgreements().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/customer-specific-pricing/update-pricing-agreements`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CustomerSpecificPricingAgreementToJSON(
          requestParameters["customerSpecificPricingAgreement"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updatePricingAgreements(
    requestParameters: UpdatePricingAgreementsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updatePricingAgreementsRaw(requestParameters, initOverrides);
  }
}
